import createAttachmentFiles from '../../utils/createAttachmentFiles';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { ComposeTarget, lazyOpenCompose, } from 'owa-mail-compose-store';
export function displayNewMessageForm(toRecipients, ccRecipients, bccRecipients, subject, htmlBody, attachments) {
    if (isMailFeatureEnabled('rp-popouts')) {
        var composeInitProps = {
            operation: 0 /* New */,
            bodyType: 'HTML',
            subject: subject,
            newContent: htmlBody,
            to: toRecipients,
            cc: ccRecipients,
            bcc: bccRecipients,
            preferAsyncSend: true,
        };
        var attachmentFiles = createAttachmentFiles(attachments);
        lazyOpenCompose.importAndExecute(composeInitProps, ComposeTarget.Popout, null /* groupId */, attachmentFiles);
    }
}
//# sourceMappingURL=DisplayNewMessageFormAdapter.js.map